import Splide from '@splidejs/splide';

class Slider {
  constructor(element) {
    this.blockElement = element;
    this.splideElement = this.blockElement.querySelector('.splide');
    this.currentSlideElement = null;
    this.totalSlidesElement = null;
    this.splide = null;
    this.prevBtn = null;
    this.nextBtn = null;
    this.toggleBtn = null;
    this.isPlaying = true;
  }

  /**
   * Lokalizuje elementy licznika slajdów.
   */
  initCounter() {
    const counterContainer = this.splideElement.querySelector(
      '.slider-block__counter-container'
    );
    if (counterContainer) {
      this.currentSlideElement =
        counterContainer.querySelector('.current-slide');
      this.totalSlidesElement = counterContainer.querySelector('.total-slides');
      return true;
    }
    return false;
  }

  /**
   * Aktualizuje wyświetlane numery slajdów.
   */
  updateCounter() {
    if (this.currentSlideElement && this.totalSlidesElement && this.splide) {
      const current = this.splide.index + 1;
      const total = this.splide.Components.Slides.getLength();
      this.currentSlideElement.textContent = current;
      this.totalSlidesElement.textContent = total;
    }
  }

  /**
   * Inicjalizuje customowe strzałki.
   */
  initCustomArrows(options) {
    this.prevBtn = this.blockElement.querySelector(`.${options.classes.prev}`);
    this.nextBtn = this.blockElement.querySelector(`.${options.classes.next}`);

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.splide.go('<');
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.splide.go('>');
      });
    }
  }

  /**
   * Aktualizuje stan strzałek (disabled/enabled).
   */
  updateArrowsState() {
    if (!this.prevBtn || !this.nextBtn || !this.splide) {
      return;
    }

    const index = this.splide.index;
    const lastIndex = this.splide.Components.Slides.getLength() - 1;
    const options = this.splide.options;

    if (options.rewind || options.type === 'loop') {
      this.prevBtn.disabled = false;
      this.nextBtn.disabled = false;
      return;
    }

    this.prevBtn.disabled = index === 0;
    this.nextBtn.disabled = index === lastIndex;
  }

  /**
   * Inicjalizuje przycisk play/pause.
   */
  initPlayPause() {
    this.toggleBtn = this.blockElement.querySelector('.slider-block__toggle');

    if (!this.toggleBtn || !this.splide) {
      return;
    }

    const playIcon = this.toggleBtn.querySelector(
      '.slider-block__toggle--play'
    );
    const pauseIcon = this.toggleBtn.querySelector(
      '.slider-block__toggle--pause'
    );
    const playText = this.toggleBtn.dataset.playtext;
    const pauseText = this.toggleBtn.dataset.pausetext;

    this.toggleBtn.addEventListener('click', () => {
      const autoplay = this.splide.Components.Autoplay;

      if (!autoplay) {
        return;
      }

      if (this.isPlaying) {
        autoplay.pause();
        this.isPlaying = false;
        this.toggleBtn.setAttribute('aria-pressed', 'true');
        this.toggleBtn.setAttribute('aria-label', playText);

        if (playIcon && pauseIcon) {
          playIcon.classList.remove('d-none');
          pauseIcon.classList.add('d-none');
        }
      } else {
        autoplay.play();
        this.isPlaying = true;
        this.toggleBtn.setAttribute('aria-pressed', 'false');
        this.toggleBtn.setAttribute('aria-label', pauseText);

        if (playIcon && pauseIcon) {
          playIcon.classList.add('d-none');
          pauseIcon.classList.remove('d-none');
        }
      }
    });
  }

  init() {
    if (!this.splideElement) {
      return;
    }

    const options = JSON.parse(
      this.splideElement.dataset.splideOptions || '{}'
    );
    options.arrows = false;

    if (!options.classes) {
      options.classes = {};
    }

    this.splide = new Splide(this.splideElement, options);

    const hasCounter = this.initCounter();
    const hasCustomArrows = this.blockElement.querySelector(
      '.slider-block__controls'
    );

    if (hasCounter) {
      this.splide.on('mounted', () => {
        this.updateCounter();
      });

      this.splide.on('move', () => {
        this.updateCounter();
      });

      this.splide.on('resized', () => {
        this.updateCounter();
      });
    }

    if (hasCustomArrows) {
      this.splide.on('mounted', () => {
        this.initCustomArrows(options);
        this.updateArrowsState();
      });

      this.splide.on('move', () => {
        this.updateArrowsState();
      });

      this.splide.on('resized', () => {
        this.updateArrowsState();
      });
    }

    this.splide.on('mounted', () => {
      this.initPlayPause();
    });

    this.splide.mount();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider-block').forEach((blockElement) => {
    const instance = new Slider(blockElement);
    instance.init();
  });
});

if (typeof acf !== 'undefined') {
  acf.addAction('ready', () => {
    document.querySelectorAll('.slider-block').forEach((blockElement) => {
      const instance = new Slider(blockElement);
      instance.init();
    });
  });

  acf.addAction('append', () => {
    document.querySelectorAll('.slider-block').forEach((blockElement) => {
      const instance = new Slider(blockElement);
      instance.init();
    });
  });
}
